import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useAppConfig } from "@/contexts/AppConfigContext";
import { analytics, TRACKING_CONSENT_RESET_EVENT } from "@/utils/analytics";
import CookieBanner from "./CookieBanner";

export default function CookieConsentController() {
  const { usesExternalConsent } = useAppConfig();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(() => analytics.getTrackingConsent() !== null);
  const enabled = !usesExternalConsent;

  useEffect(() => {
    analytics.configureConsentRequirement(true);
    analytics.initialize();
  }, []);

  useEffect(() => {
    analytics.page(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const handleConsentReset = () => {
      if (enabled) setDismissed(false);
    };
    window.addEventListener(TRACKING_CONSENT_RESET_EVENT, handleConsentReset);
    return () => window.removeEventListener(TRACKING_CONSENT_RESET_EVENT, handleConsentReset);
  }, [enabled]);

  const handleOnlyNecessary = () => {
    analytics.setTrackingConsent("denied");
    setDismissed(true);
  };

  const handleAcceptAll = () => {
    analytics.setTrackingConsent("granted");
    analytics.page(location.pathname);
    setDismissed(true);
  };

  if (!enabled || dismissed) return null;

  return <CookieBanner onOnlyNecessary={handleOnlyNecessary} onAcceptAll={handleAcceptAll} />;
}
